<template>
  <div>
    <!-- STORE VIEW -->
    <Drawer class="drawer_modal"
            width="700"
            v-model="storeShow.show">
      <storeDetail
        v-if="storeShow.show"
        :id="storeShow.id"
        :base_view_url="baseStore"
        :item_type="storeShow.type"
        @click_cancel="storeShow.show = false"
      ></storeDetail>
    </Drawer>

    <!-- CUSTOMER VIEW -->
    <Drawer class="drawer_modal"
            width="700"
            v-model="customerShow.show">
      <customerDetail
        v-if="customerShow.show"
        :id="customerShow.id"
        :base_view_url="baseCustomer"
        :item_type="customerShow.type"
        @click_cancel="customerShow.show = false"
      ></customerDetail>
    </Drawer>

    <!-- SUPPLIER VIEW -->
    <Drawer class="drawer_modal"
            width="700"
            v-model="supplierShow.show">
      <supplierDetail
        v-if="supplierShow.show"
        :id="supplierShow.id"
        :base_view_url="baseSupplier"
        :item_type="supplierShow.type"
        @click_cancel="supplierShow.show = false"
      ></supplierDetail>
    </Drawer>


    <Drawer class="drawer_modal"
            width="700"
            v-model="productOrderShow.show">
      <productOrderDetail
        v-if="productOrderShow.show"
        :id="productOrderShow.id"
        :base_view_url="baseProductOrder"
        :item_type="productOrderShow.type"
        @click_cancel="productOrderShow.show = false"
      ></productOrderDetail>
    </Drawer>



  </div>
</template>


<script>
    import {base_url} from "../../http.js";
    import storeDetail from "@/apps/store/storeDetail.vue";
    import customerDetail from "@/apps/customer/customerDetail.vue";
    import supplierDetail from "@/apps/supplier/supplierDetail.vue";
    import productOrderDetail from "@/apps/product_order/productOrderDetail.vue";

    export default {
        components: {
            storeDetail,
            customerDetail,
            supplierDetail,
            productOrderDetail,
        },

        props: ['item'],

        data() {
            return{
                baseStore: base_url + "/stores/",
                baseCustomer: base_url + "/customers/",
                baseSupplier: base_url + "/suppliers/",
                baseProductOrder: base_url + "/product_orders/",

                drawerItem: {
                    show: false,
                    id: null,
                    type: null
                },
            }
        },

        computed: {
            storeShow() {
                if(this.item.type === 'store') return this.item;
                else return this.drawerItem
            },
            customerShow() {
                if(this.item.type === 'customer') return this.item;
                else return this.drawerItem
            },
            supplierShow() {
                if(this.item.type === 'supplier') return this.item;
                else return this.drawerItem
            },
            productOrderShow() {
                if(this.item.type === 'product_order') return this.item;
                else return this.drawerItem
            }
        }
    }



</script>



// WEBPACK FOOTER //
// src/apps/partial/drawers.vue